/** Generated from ELineCoverage.java. Do not modify this file! */


export type ELineCoverageEntry = 'NOT_COVERED' | 'PARTIALLY_COVERED' | 'FULLY_COVERED';

export class ELineCoverage {
	static readonly NOT_COVERED = new ELineCoverage(0, 'NOT_COVERED');
	static readonly PARTIALLY_COVERED = new ELineCoverage(1, 'PARTIALLY_COVERED');
	static readonly FULLY_COVERED = new ELineCoverage(2, 'FULLY_COVERED');
	static readonly values = [
		ELineCoverage.NOT_COVERED,
		ELineCoverage.PARTIALLY_COVERED,
		ELineCoverage.FULLY_COVERED
	];



	private constructor (
		public readonly ordinal: number,
		public readonly name: ELineCoverageEntry,

	){
	}

	toString() {
		return this.name;
	}

	/** Returns the enum value of the provided enum entry. */
	public static valueOf(entry: ELineCoverageEntry): ELineCoverage;
	/** Returns the enum value of the provided enum entry. Returns undefined if entry was undefined. */
	public static valueOf(entry: ELineCoverageEntry | undefined): ELineCoverage | undefined;
	public static valueOf(entry: ELineCoverageEntry | undefined): ELineCoverage | undefined {
		if (entry === undefined) {
			return undefined;
		}
		return ELineCoverage[entry];
	}
}

